/* eslint-disable no-unused-vars */
export enum ExecutionRequestStatus {
  Sent = "Sent",
  Received = "Received",
  Quoted = "Quoted",
  ReQuoted = "Re-Quoted",
  ReQuoteRequested = "Re-Quote Requested",
  QuotedExpired = "Quoted Expired",
  OffQuote = "Off-Quote",
  InvalidQuote = "Invalid Quote",
  Awarded = "Awarded",
  Executed = "Executed",
  DealtAway = "Dealt Away",
  Affirmed = "Affirmed",
  AffirmedPend = "Affirmed-Pend",
  Recalled = "Recalled",
  Archived = "Archived",
  Closed = "Closed",
  NotDealt = "Not Dealt",
  Acknowledged = "Acknowledged",
  Pulled = "Pulled",
  LevelAccepted = "Level Accepted",
  Working = "Working",
  LevelUpdated = "Level Updated",
  LevelUpdatedCP = "Level Updated - CP",
  PartiallyFilled = "Partially Filled",
  FilledIncomplete = "Filled - Incomplete",
  ReSent = "Re-Sent",
  Rejected = "Rejected",
  ExecutedPend = "Executed-Pend",
  ExecutedRPChangeRequested = "Executed - RP Change Requested",
  ExecutedPendRPChangeRequested = "Executed-Pend - RP Change Requested",
  ExecutedRPAgreeChange = "Executed - RP Agree Change",
  ExecutedPendRPAgreeChange = "Executed-Pend - RP Agree Change",
  ExecutedOPChangeRequested = "Executed - OP Change Requested",
  ExecutedPendOPChangeRequested = "Executed-Pend - OP Change Requested",
  Filled = "Filled",
  NoMoreFills = "No More Fills",
  QuoteExpired = "QuoteExpired",
}
